const ROUTES = {
  home: '/',
  bell: '/bell',
  tsn: '/tsn',
  crave: '/crave',
  vod: '/vod',
  live: '/live',
  about: '/about',
  category: '/category',
  epg: '/epg',
  info: '/info',
  login: '/login',
  viewAll: '/view-all',
  movieDetails: '/movie',
  myContent: '/mycontent',
  paringCode: '/pairing-code',
  profile: '/profile',
  resetPassword: '/reset-password',
  search: '/search',
  show: '/show',
  showDetails: '/tvshow',
  player: '/player',
  programDetails: '/program'
} as const; // TODO: Devs please align with your routesMapping

const PROVIDER_TYPE = {
  cms: 'cms',
  i18n: 'i18n',
  ovp: 'ovp',
  amagi: 'amagi'
} as const;

const SHELF_CONTAINER_IDS = {
  Carousel: 'Carousel',
  Default: 'Default',
  Grid: 'Grid',
  HeroBanner: 'HeroBanner',
  ImageHeroBanner: 'ImageHeroBanner',
  ChannelBanner: 'ChannelBanner',
  ChannelBannerImage: 'ChannelBannerImage',
  FilterSort: 'FilterSort'
} as const;

const {
  Carousel,
  Grid,
  HeroBanner,
  ImageHeroBanner,
  ChannelBanner,
  ChannelBannerImage,
  FilterSort
} = SHELF_CONTAINER_IDS;

/* These are manually used templates */
const CUSTOM_CONTAINER_ID_TEMPLATE_MAP = {
  'carousel-link': Carousel,
  'featured-carousel-portrait': Carousel,
  'carousel-landscape': Carousel,
  'grid-portrait-loadmore': Grid,
  'grid-wide-loadmore': Grid
} as const;

/* These are templates from Accedo One Control */
const ACCEDO_CONTROL_CONTAINER_TEMPLATES = {
  hero: 'elevate-hero-banner',
  imageHero: 'elevate-hero-image-banner',
  continueWatching: 'elevate-continue-watching',
  carouselPortrait: 'elevate-carousel-portrait',
  carouselWide: 'elevate-carousel-wide',
  carouselCategoryPortrait: 'elevate-carousel-category-portrait',
  carouselCategoryWide: 'elevate-carousel-category-wide',
  gridHorizontalPortrait: 'elevate-grid-horizontal-portrait',
  gridHorizontalWide: 'elevate-grid-horizontal-wide',
  gridVerticalPortrait: 'elevate-grid-vertical-portrait',
  gridVerticalWide: 'elevate-grid-vertical-wide',
  carouselViewAllPortrait: 'elevate-carousel-view-all-portrait',
  carouselCategories: 'elevate-carousel-categories',
  filterSort: 'elevate-filter-sort', // to be deprecated
  carouselJumpRecommendation: 'elevate-jump-portrait',
  channelsRail: 'elevate-channels',
  channelsRailAmagi: 'elevate-channels-amagi-live',
  channelsRailBellImage: 'elevate-channels-bell-live-image',
  carouselPortraitAmagi: 'elevate-carousel-portrait-amagi',
  carouselWideAmagi: 'elevate-carousel-wide-amagi',
  carouselWideAmagiLiveEvent: 'elevate-carousel-wide-amagi-live-event',
  heroAmagiLiveEvent: 'elevate-hero-banner-amagi-live-event',
  carouselPortraitBell: 'elevate-carousel-portrait-bell',
  carouselWideBell: 'elevate-carousel-wide-bell',
  carouselPortraitCrave: 'elevate-carousel-portrait-crave',
  carouselWideCrave: 'elevate-carousel-wide-crave'
} as const;

const DEFAULT_TEMPLATE = ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselPortrait;

const ACCEDO_CONTROL_CONTAINER_ID_TEMPLATE_MAP = {
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.hero]: HeroBanner,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.imageHero]: ImageHeroBanner,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.heroAmagiLiveEvent]: HeroBanner,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.continueWatching]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselPortrait]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselWide]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselPortraitAmagi]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselWideAmagi]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselPortraitBell]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselWideBell]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselPortraitCrave]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselWideCrave]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselWideAmagiLiveEvent]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.gridVerticalPortrait]: Grid,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.gridVerticalWide]: Grid,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselViewAllPortrait]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselCategories]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.filterSort]: FilterSort,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselJumpRecommendation]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.channelsRail]: ChannelBanner,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.channelsRailAmagi]: ChannelBanner,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.channelsRailBellImage]: ChannelBannerImage
} as const;

const CONTAINER_ID_TEMPLATE_MAP = {
  ...ACCEDO_CONTROL_CONTAINER_ID_TEMPLATE_MAP,
  ...CUSTOM_CONTAINER_ID_TEMPLATE_MAP
} as const;

const CONTAINER_ITEM_TYPES = {
  Movie: 'movie',
  TvShow: 'tvshow',
  Episode: 'episode',
  Category: 'category',
  Show: 'show',
  Bookmark: 'bookmark',
  Live: 'live',
  Program: 'program',
  Other: 'other'
} as const;

const DETAIL_ROUTES = {
  [CONTAINER_ITEM_TYPES.Movie]: '/movie/:item-id:',
  [CONTAINER_ITEM_TYPES.TvShow]: '/show/:item-id:',
  [CONTAINER_ITEM_TYPES.Bookmark]: '/player',
  [CONTAINER_ITEM_TYPES.Live]: '/player',
  [CONTAINER_ITEM_TYPES.Episode]: '/show/:item-id:',
  [CONTAINER_ITEM_TYPES.Category]: '/category/:item-id:',
  // [CONTAINER_ITEM_TYPES.ContinueWatching]: '/player',
  [CONTAINER_ITEM_TYPES.Program]: '/program/:item-id:'
} as const; // TODO: Devs please align with your routesMapping

// multi-audios/subtitles HLS video
const DEFAULT_HLS_STREAM = '//playertest.longtailvideo.com/adaptive/elephants_dream_v4/redundant.m3u8' as const;

const DETAIL_TYPES = {
  [CONTAINER_ITEM_TYPES.Movie]: 'movie',
  [CONTAINER_ITEM_TYPES.Episode]: 'episode',
  [CONTAINER_ITEM_TYPES.Show]: 'show',
  [CONTAINER_ITEM_TYPES.Program]: 'program'
} as const;

const ITEM_TYPES = {
  Wide: 'wide',
  Portrait: 'portrait',
  WideBell: 'wide-bell',
  PortraitBell: 'portrait-bell',
  FeaturedCarouselPortrait: 'featured-carousel-portrait',
  GridPortrait: 'grid-portrait',
  GridLandscape: 'grid-landscape',
  Landscape: 'landscape',
  Square: 'square',
  Bookmark: 'bookmark',
  SeasonEpisode: 'season-episode',
  Categories: 'categories',
  EPGCategories: 'epg-categories',
  SearchMovie: 'search-movie',
  SearchEpisode: 'search-episode',
  Trend: 'trend'
} as const;

const ANALYTICS_SCREEN_TYPES = {
  epg: 'epg',
  details: 'details',
  login: 'login',
  category: 'category',
  myContent: 'myContent',
  pairing: 'pairing',
  page: 'page',
  player: 'player',
  profile: 'profile',
  resetPassword: 'resetPassword',
  search: 'search',
  settings: 'settings'
} as const;

const PAGE_TEMPLATES = {
  modular: 'elevate-modular-ui',
  myContent: 'elevate-my-content',
  profile: 'elevate-profile',
  search: 'elevate-search',
  signin: 'elevate-sign-in',
  epg: 'elevate-epg',
  info: 'elevate-info',
  player: 'elevate-player',
  category: 'elevate-category',
  about: 'elevate-about',
  pairing: 'elevate-pairing',
  resetPassword: 'elevate-reset-password',
  viewAll: 'elevate-view-all',
  showDetail: 'elevate-show-detail',
  movieDetail: 'elevate-movie-detail',
  programDetail: 'elevate-program-detail'
} as const;

const IMAGE_TYPE = {
  THUMBNAIL: 'thumbnail',
  COVER: 'cover',
  POSTER: 'poster',
  BACKDROP: 'backdrop',
  BANNER: 'banner'
} as const;

const QUALITIES = {
  DEV: 20,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  PROD: __IMAGE_Q__ || 65
};

export {
  ACCEDO_CONTROL_CONTAINER_TEMPLATES,
  ACCEDO_CONTROL_CONTAINER_ID_TEMPLATE_MAP,
  ANALYTICS_SCREEN_TYPES,
  CONTAINER_ITEM_TYPES,
  CONTAINER_ID_TEMPLATE_MAP,
  DEFAULT_HLS_STREAM,
  DEFAULT_TEMPLATE,
  DETAIL_ROUTES,
  DETAIL_TYPES,
  ITEM_TYPES,
  PROVIDER_TYPE,
  SHELF_CONTAINER_IDS,
  ROUTES,
  PAGE_TEMPLATES,
  IMAGE_TYPE,
  QUALITIES
};
